module.exports = __webpack_public_path__ + "static/media/Artboard26.9e5d8f16.png";